<template>
  <div id="app">
    <k-navigation />
    <k-cart-button />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <k-footer v-if="site && $route.name !== 'placeholder'" />
  </div>
</template>

<script>
import { mapState } from "vuex";
const KNavigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
const KCartButton = () =>
  import(/* webpackChunkName: "KCartButton" */ "@/components/CartButton.vue");
const KFooter = () =>
  import(/* webpackChunkName: "Footer" */ "@/components/Footer.vue");
export default {
  name: "App",
  metaInfo() {
    return {
      titleTemplate: "Koivu" + " %s",
    };
  },
  components: {
    KNavigation,
    KFooter,
    KCartButton,
  },
  computed: mapState(["site"]),
  created() {
    this.$store.dispatch("loadSite");
    this.$store.dispatch("loadHome");
  },
  mounted() {
    // window.addEventListener("resize", this.appHeight);
    this.appHeight();
  },
  methods: {
    appHeight() {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    },
  },
};
</script>
